import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SidebarEntry } from '../../models/sidebarEntry';
import { SideBarService } from '../../services/sideBarService';
import { UrlService } from '../../services/url.service';

@Component({
  selector: 'app-side-bar',
  templateUrl: './sideBar.component.html'
})

export class SideBarComponent implements OnInit {
  constructor(private sideBarService: SideBarService, private urlService: UrlService, private route: ActivatedRoute, private router: Router) { }

  MenuItems: SidebarEntry[] = [];
  menuElement: HTMLElement;
  visible: boolean = false;
  environment: string = 'pro';

  showMenu = function(show: boolean) {
    this.menuElement.style.display = show ? 'block' : 'none';
  }

  ngOnInit() {
    this.urlService.GetConfigurationData().then(data=> this.environment = data.BOEnvironment);

    this.menuElement = document.getElementById('showLeftPush');
    this.menuElement.addEventListener('click',() => {
      this.visible = !this.visible;
    });

    this.sideBarService.getItems().subscribe(items=>{
      this.MenuItems = items;
      this.showMenu(items.length > 0);
    });
  }

   close(){
     this.visible = false;
   }
}





// WEBPACK FOOTER //
// ./src/app/shared/components/sideBar/sideBar.component.ts